<div class="chart-container">
    <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="internalChartOptions()"
        (chartInstance)="onChartInstance($event)"
        [(update)]="updateFlag"></highcharts-chart>
</div>